import { Component } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { services } from '../../services';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslationService } from '../../../../../../shared/services/translations.service';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'marvel-net-wins',
  templateUrl: './marvel-net-wins.component.html'
})
export class MarvelNetWinsComponent {
  service = 'netwins';
  availableServices = services['marvel'].filter(service => service.service !== this.service);

  serviceParams = {
    game: 'marvel',
    service: 'netwins',
    type: 'solo',
    title: {
      en: 'Net Wins',
    },
    subtitle: {
      en: 'Guaranteed Competitive Wins in Solo or Duo Boosting',
      fr: 'Garantie de victoires compétitives en boost solo ou duo',
      de: 'Garantierte Wettkampf-Siege im Solo- oder Duo-Boosting',
      pt: 'Vitórias Competitivas garantidas em Solo ou Duo Boosting',
      es: 'Victorias competitivas garantizadas en boost solo o dúo',
    },
    start: 4,
    desired: 3,
    serviceName: 'Net Wins',
    min: 1,
    max: 3
  }

  serviceFaqs = {
    en: [
      {
        question: "What Is A Net Win Boost?",
        answer: "A Net Win boost is the difference between the number of victories and losses. For each loss, you receive an additional win. ex: 2 Net Wins = 2W-0L or 3W-1L."
      },
      {
        question: "What If I Reach A New Tier And Still Have Net Wins Remaining?",
        answer: "In ranks below Celestial we play one tier above the initial rank. In Celestial+, net wins are only valid for the purchased tier."
      },
      {
        question: "Can I Play With The Booster In Duo Queue Boosting?",
        answer: "Indeed, you can. To accomplish this, go to the order customization menu and select \"Duo\" before clicking \"Buy Boost Now.\""
      },
    ],
    fr: [
      {
        question: "Qu\'est-ce qu\'un Boost de Net Wins",
        answer: "Une Net Wins est la différence entre le nombre de victoires et le nombre de défaites. Pour chaque défaite, vous recevez une victoire supplémentaire. ex : 2 victoires nettes = 2V-0D ou 3V-1D."
      },
      {
        question: "Et si j'atteins un nouveau palier mais qu'il me reste encore des victoires nettes ?",
        answer: "Dans les rangs en dessous de Céleste, on joue un palier au-dessus du rang initial. En Céleste+, les victoires nettes sont valables uniquement pour le palier acheté."
      },
      {
        question: "Puis-je jouer en duo avec le booster?",
        answer: "En effet, vous pouvez le faire. Pour ce faire, allez dans le menu de personnalisation de la commande et sélectionnez \"Duo\" avant de cliquer sur \"Acheter Boost maintenant\"."
      },
    ],
    de: [
      {
        question: "Was ist ein Net Win Boost?",
        answer: "Ein Net Win Boost ist die Differenz zwischen der Anzahl der Siege und der Anzahl der Niederlagen. Für jede Niederlage erhältst du einen zusätzlichen Sieg. z.B.: 2 Net Wins = 2W-0L oder 3W-1L."
      },
      {
        question: "Was passiert, wenn ich ein neues Tier erreiche, aber noch Nettosiege übrig habe?",
        answer: "In Rängen unterhalb von Celestial spielen wir ein Tier über dem ursprünglichen Rang. In Celestial+ gelten Nettosiege nur für das gekaufte Tier."
      },
      {
        question: "Kann ich mit dem Booster im Duo Queue Boosting spielen?",
        answer: "Ja, das kannst du. Gehe dazu in das Menü zur Bestellungsanpassung und wähle \"Duo\" aus, bevor du auf \"Boost Jetzt Kaufen\" klickst."
      },
    ],
    pt: [
      {
        question: "O que é um Net Win Boost?",
        answer: "Net Win Boost é a diferença entre o número de vitórias e derrotas. Exemplo, 1 Net Win pode ser 1 Vitória e 0 Derrotas, ou 2 Vitórias e 1 Derrota."
      },
      {
        question: "E se eu alcançar um novo tier e ainda tiver vitórias líquidas restantes?",
        answer: "Nos ranks abaixo de Celestial, jogamos um tier acima do rank inicial. Em Celestial+, as vitórias líquidas são válidas apenas para o tier comprado."
      },
      {
        question: "Posso Jogar com o Booster em Duo Queue?",
        answer: "Sim, podes. Para fazer isso, vai ao menu de personalização do pedido e seleciona \"Duo\" antes de clicar em \"Comprar Boost Agora\"."
      },
    ],
    es: [
      {
        question: "¿Qué es un \"Net Win Boost\"?",
        answer: "Un Boost de Net Win es la diferencia entre el número de victorias y derrotas. Por cada derrota, recibes una victoria adicional. ej: 2 Net Wins = 2W-0L o 3W-1L."
      },
      {
        question: "¿Qué pasa si alcanzo un nuevo rango pero aún me quedan victorias netas?",
        answer: "En los rangos por debajo de Celestial, jugamos un rango por encima del inicial. En Celestial+, las victorias netas solo son válidas para el rango comprado."
      },
      {
        question: "¿Puedo jugar con los boosters en Duo Queue Boosting?",
        answer: "Efectivamente, puedes hacerlo. Para ello, ve al menú de personalización del pedido y selecciona \"Duo\" antes de hacer clic en \"Comprar Boost ahora\"."
      },
    ]
  }

  private page = {
    title: {
      en: "Marvel Rivals Boosting - Net Wins Boosting for Marvel Rivals",
      fr: "Marvel Rivals Boosting - Boosting de Net Wins sur Marvel Rivals",
      de: "Marvel Rivals Boosting - Net Wins Boosting für Marvel Rivals",
      pt: "Marvel Rivals Boosting - Boost de Net Wins para Marvel Rivals",
      es: "Marvel Rivals Boosting - Boost de Net Wins para Marvel Rivals",
    },
    metaDescription: {
      en: "Looking to improve your normal game MMR in Marvel Rivals? Our affordable, fast, and secure service will help you queue against better players!",
      fr: "Vous cherchez à améliorer votre MMR en partie normale sur Marvel Rivals ? Notre service abordable, rapide et sécurisé vous permettra d\'affronter de meilleurs joueurs!",
      de: "Du möchtest deine MMR verbessern, indem du dich mit anderen Spielern in Marvel Rivals triffst? Wir helfen dir dabei, dich mit besseren Spielern zu messen - kostengünstig, schnell und sicher!",
      pt: "Procurando melhorar o teu MMR de normal wins no Marvel Rivals? O nosso serviço acessível, rápido e seguro ajudar-te-á a enfrentar jogadores melhores!",
      es: "¿Quieres mejorar tu MMR de juego normal en Marvel Rivals? ¡Nuestro servicio asequible, rápido y seguro te ayudará a hacer cola contra mejores jugadores!",
    }
  }

  lang: string = 'en';

  constructor(meta: Meta, title: Title, private route: ActivatedRoute, private router: Router, private cookie: CookieService, private translationService: TranslationService,) {
    this.route.params.subscribe(params => {
      if (Object.keys(params).length === 0) {
        const url = this.router.url.split('/');
        if (this.translationService.validLangs.includes(url[1])) {
          this.lang = url[1];
        } else {
          this.lang = this.cookie.get('gg-lang') || 'en';
        }
      } else {
        this.lang = params['lang'] || 'en';
      }

      title.setTitle(this.page.title[this.lang] || this.page.title['en']);
      meta.updateTag(
        {
          name: 'description',
          content: this.page.metaDescription[this.lang] || this.page.metaDescription['en']
        }
      );
    });
  }
}